export interface Workflow {
    id: string,
    name: string,
    flow: string | null,
    query: string | null,
    meta: string | null,
    createdAt: Date,
    updatedAt: Date,
    public: boolean,
    status: WorkflowStatus,
    users: WorkflowUser[]
}

export interface WorkflowUser{
    id: string
    userId: string,
    role: WorkflowUserRole,
    workflowId: string
}

export enum WorkflowStatus {
    DRAFT = 'DRAFT',
    COMPILING = 'COMPILING',
    COMPILED = 'COMPILED',
    PUBLISHING = 'PUBLISHING',
    RUNNING = 'RUNNING',
    PUBLISHED = 'PUBLISHED',
    STOPPING = 'STOPPING',
    STOPPED = 'STOPPED',
    COMPLETED = 'COMPLETED',
    ERROR = 'ERROR',
    DSL_ERROR = 'DSL_ERROR'
}

export enum WorkflowUserRole {
    OWNER = 'OWNER',
    EDITOR = 'EDITOR',
    VIEWER ='VIEWER'
}

export interface MarketplaceItem {
    id: string,
    name: string,
    type: MarketplaceItemType,
    createdAt: Date,
    updatedAt: Date,
    description?: string,
    icon?: string,
    owner?: string,
    extraData?: string,
}

export enum MarketplaceItemType {
    FAAS = "FAAS",
    ML = "ML",
    FUSION = "FUSION",
    WORKFLOW = "WORKFLOW"
}

export interface UploadInSituResponse {
    dataPath: string,
    metaDataPath?: string,
    workflowId: string,
}

export interface CreateMarketplaceItemRequest {
    name: string,
    type: MarketplaceItemType,
    description?: string,
    icon?: string,
    extraData?: string,
    public?: boolean
}

export interface UpdateMarketplaceItemRequest {
    name?: string,
    description?: string,
    icon?: string,
    extraData?: string,
    public?: boolean
}
